<div class="deck-container">
  <div class="deck-image">
    <img style="width: 100px;" src="../../assets/back.svg">
  </div>
  <div class="deck-text">
    <h4 style="color: darkgray;">How many cards are left?</h4>
    <h3>{{ this.deckCount }} cards remain</h3>
  </div>
</div>